import { render, staticRenderFns } from "./ReceiveByPOMGT.vue?vue&type=template&id=69f1b1b2&scoped=true&"
import script from "./ReceiveByPOMGT.vue?vue&type=script&lang=js&"
export * from "./ReceiveByPOMGT.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveByPOMGT.vue?vue&type=style&index=0&id=69f1b1b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f1b1b2",
  null
  
)

export default component.exports